import Image from 'next/image'
import { useState } from 'react'

const LazyImage = ({ src, index, width, height, alt, ...props }) => {
  const [blur, setBlur] = useState(true)
  const getSmallImageSrc = (src) => {
    // Ensure src is a string before calling replace
    if (typeof src === 'string') {
      return src.replace(/\b(1980|3840|640|960|360)\b/g, '64')
    }
    return null
  }

  const isLayout = props.layout === 'fill'

  // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
  // eslint-disable-next-line no-unused-vars
  const { srcSet, sizes, ...imageProps } = props

  // Only render if src is a valid string
  if (src && typeof src === 'string') {
    const blurDataURL = getSmallImageSrc(src)

    return (
      <Image
        width={!isLayout && (width || 590)}
        height={!isLayout && (height || 393)}
        src={src}
        blurDataURL={blurDataURL}
        placeholder={blurDataURL ? 'blur' : 'empty'}
        className={blur ? 'img-blur' : 'unblur'}
        onLoadingComplete={() => setBlur(false)}
        alt={alt || `Property presentation image ${index}`}
        {...imageProps}
      />
    )
  }
  return null
}

export default LazyImage
